const {
  REACT_APP_ENVIRONMENT,
  REACT_APP_BASE_API_URL,
  REACT_APP_API_DEBUGGING,
  REACT_APP_ORIGINAL_URI,
  REACT_APP_PUBLIC_URL,

  REACT_APP_MAINTENANCE_BANNER_SHOW,
  REACT_APP_MAINTENANCE_BANNER_TEXT_COLOR,
  REACT_APP_MAINTENANCE_BANNER_BACKGROUND_COLOR,
  REACT_APP_MAINTENANCE_BANNER_TEXT,

  REACT_APP_OKTA_ISSUER,
  REACT_APP_OKTA_CLIENT_ID,
  REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK,
} = process.env;

export const settings = {
  maintenance_banner: {
    MAINTENANCE_BANNER_SHOW: REACT_APP_MAINTENANCE_BANNER_SHOW,
    MAINTENANCE_BANNER_TEXT_COLOR:
      REACT_APP_MAINTENANCE_BANNER_TEXT_COLOR || 'black',
    MAINTENANCE_BANNER_BACKGROUND_COLOR:
      REACT_APP_MAINTENANCE_BANNER_BACKGROUND_COLOR || 'yellow',
    MAINTENANCE_BANNER_TEXT:
      REACT_APP_MAINTENANCE_BANNER_TEXT ||
      'Rabbit Portal will be down for maintenance contact your administrator for times',
  },
  okta: {
    OKTA_ISSUER: REACT_APP_OKTA_ISSUER,
    OKTA_CLIENT_ID: REACT_APP_OKTA_CLIENT_ID,
    OKTA_TESTING_DISABLEHTTPSCHECK: REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  API_BASE_URL: REACT_APP_BASE_API_URL,
  API_DEBUGGING: REACT_APP_API_DEBUGGING === 'true',
  ENVIRONMENT: REACT_APP_ENVIRONMENT,
  DATE_FORMAT: 'yyyy-MM-dd',
  APP_ORIGINAL_URI: REACT_APP_ORIGINAL_URI,
  PUBLIC_URL: REACT_APP_PUBLIC_URL,
};

export const DATE_FORMAT = 'yyyy-MM-dd';
